import { cn } from "@/shared/lib/utils";
import {
  STAGE_BAR_COLOR,
  getStatusLabel,
  type StatusFilter,
} from "@/features/properties/services/deliveryStatusConfig";

interface Props {
  status?: string | null;
}

/** Normalize a stored delivery_status (incl. legacy values) to a known stage. */
function normalizeStage(status: string | null | undefined): StatusFilter {
  const s = (status ?? "").toLowerCase();
  if (s === "delivered" || s === "complete" || s === "completed") return "delivered";
  if (s === "in_progress" || s === "in progress") return "in_progress";
  if (s === "no_survey_scheduled") return "no_survey_scheduled";
  return "survey_scheduled";
}

/**
 * Compact per-row status: a stage-colored dot + label. Dates live in their own
 * Survey/Delivery columns. Stage colors match the portfolio progress band.
 */
export function PropertyRowStatus({ status }: Props) {
  const stage = normalizeStage(status);
  return (
    <span
      data-testid="row-status"
      data-stage={stage}
      className="inline-flex items-center gap-2 whitespace-nowrap"
    >
      <span className={cn("h-2 w-2 shrink-0 rounded-full", STAGE_BAR_COLOR[stage])} />
      <span className="text-sm text-foreground">{getStatusLabel(stage)}</span>
    </span>
  );
}
